<template>
    <div style="margin:0 -12px;">
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-4">
                    </div>
                    <div class="col text-center" style="padding-top: 25px;padding-bottom:10px;">
                        <b>好みのカード</b>
                    </div>
                    <div class="col-4 text-end">
                        <div style="display: inline-flex;">
                            <a class="libere-header-menu text-center" href="/info" style="text-decoration:none;">
                                <div class="" style="color:#cdcdcd;padding-top:7px;">
                                    <svg style="height:25px;width:25px;fill:#cdcdcd;">
                                        <use xlink:href="/images/bell.svg#bell"></use>
                                    </svg>
                                    <div class="text-nowrap" style="font-size: 8px;">
                                        通知
                                    </div>
                                </div>
                            </a>
                            <div style="color:red;position: absolute;right: 22px;" v-if="info_count != 0">●</div>
                            <div style="width:15px;"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container" style="height: 100%;"
            v-if="is_page_init_attention_card || is_page_init_my_card || is_page_init_card">
            <div class="row" style="height: 100%">
                <div class="col" style="height: 100%">
                    <div class="text-center" style="height: 100%">
                        <div class="spinner-grow" role="status" style="margin-top:300px;color:#E7E7FF;">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap" v-else>
            <div class="container-fluid" style="padding-top:70px;">
                <div class="row">
                    <div class="col">
                        <div style="padding:0 10px;">
                            <div class="row" style="padding-bottom: 20px;">
                                <div class="col">
                                    <div class="search_box">
                                        <input type="text" class="" @keypress.enter="setWord" v-model="search_word"
                                            placeholder="キーワードを入力">
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="my_cards_count == 0">
                                <div class="col px-0">
                                    <div style="margin-left:-10px;margin-right:-10px;">
                                        <img src="/images/Group13158.png" class="img-fluid">
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-else>
                                <div class="col">
                                    <div class="row" style="padding-bottom:10px;">
                                        <div class="col-7">
                                            <b>あなたが登録したカード</b>
                                        </div>
                                        <div class="col text-end">
                                            <a href="/card/bookmark" style="color:#999;font-size:13px;"><i
                                                    class="bi bi-star-fill"></i>カードの変更</a>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-4 px-0" v-for="card in my_cards" :key="card.id">
                                            <a :href="'/card/detail/' + card.cid" style="color:#000;">
                                                <div style="margin:8px;" v-if="card.is_bookmark == 0">
                                                    <img :src="card.thumbnail_image" class="luna-rounded img-fluid">
                                                    <div style="padding:3px;font-size:12px">{{ card.name }}</div>
                                                </div>
                                                <div style="margin:8px;position:relative" v-else>
                                                    <i class="bi bi-star-fill"
                                                        style="position:absolute;right:6px;top:2px; font-size:23px;color:#6B4EFF;z-index:99;"></i>
                                                    <img :src="card.thumbnail_image" class="luna-rounded img-fluid"
                                                        style="border:3px solid #6B4EFF;">
                                                    <div style="padding:3px;font-size:12px">{{ card.name }}</div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="row" v-if="my_cards_count != 0">
                                        <div class="col">
                                            <div class="text-center"
                                                style="padding-top: 40px; padding-bottom: 20px; color: #6c7072"
                                                v-if="is_my_cards_page && my_cards_count != 0">
                                                <a @click="fetchMyCardMore()">もっとみる</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" v-if="is_my_cards_load_under">
                                        <div class="col text-center">
                                            <div class="spinner-grow" role="status">
                                                <span class="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col text-start" style="padding-top: 25px;">
                                    <b>カテゴリ</b>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="table-responsive">
                                        <table class="table table-borderless p-0">
                                            <tbody class="p-0">
                                                <tr class="p-0">
                                                    <td class="p-0">
                                                        <div class="row flex-nowrap" style="padding:0 10px;">
                                                            <div class="col-3 px-0" style="margin:0 5px;"
                                                                v-for="category in categorys" :key="category.id">
                                                                <a :href="'/card/category/list?type=' + category.id">
                                                                    <div class="category-box text-center"
                                                                        style="width:100%;"
                                                                        v-if="category.thumbnail_image == null">
                                                                        {{ category.name }}
                                                                    </div>
                                                                    <div :style="'background: url(' + category.thumbnail_image + ') center center no-repeat;' +
                                                                        'background-size: cover;' +
                                                                        'width:100%;' +
                                                                        'color: #fff;' +
                                                                        'border-radius: 8px;'
                                                                        " v-else>
                                                                        <div class="category-box-filter text-center"
                                                                            style="width:100%;">
                                                                            {{ category.name }}
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col text-start" style="padding-top: 25px;">
                                    <b>人気のカード</b>
                                </div>
                                <div class="col text-end" style="padding-top: 25px;color:#999;font-size:13px;">
                                    <a href="/card/popular/list" style="color:#999;font-size:13px;">
                                        すべて見る
                                    </a>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="table-responsive">
                                        <table class="table table-borderless p-0">
                                            <tbody class="p-0">
                                                <tr class="p-0">
                                                    <td class="p-0">
                                                        <div class="row flex-nowrap" style="padding:10px;">
                                                            <div class="col-10 px-0" style="margin:0 5px;">
                                                                <a :href="'/card/detail/' + popular_cards[0].id">
                                                                    <div class="card"
                                                                        style="max-width: 540px;border:0px;">
                                                                        <div class="row g-0">
                                                                            <div class="col-3">
                                                                                <div
                                                                                    v-if="popular_cards[0].card_count == 0">
                                                                                    <img :src="popular_cards[0].thumbnail_image"
                                                                                        class="luna-rounded img-fluid">
                                                                                </div>
                                                                                <div style="position:relative" v-else>

                                                                                    <svg
                                                                                        style="position:absolute;right:8px;top:5px;fill:#9990FF;z-index:99;height:25px;width:25px;">
                                                                                        <use
                                                                                            xlink:href="/images/card_check.svg#card_check">
                                                                                        </use>
                                                                                    </svg>
                                                                                    <img :src="popular_cards[0].thumbnail_image"
                                                                                        class="luna-rounded img-fluid"
                                                                                        style="border:3px solid #9990FF;">
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-9">
                                                                                <div style="padding-left:10px">
                                                                                    <div
                                                                                        style="font-size:14px;color:#000">
                                                                                        {{ popular_cards[0].name }}<span
                                                                                            v-if="popular_cards[0].card_count != 0"
                                                                                            style="color:#9990FF;">&nbsp;登録済</span>
                                                                                    </div>
                                                                                    <div
                                                                                        style="font-size:14px;color:#999">
                                                                                        {{ popular_cards[0].category
                                                                                        }}・{{
                                                                                            popular_cards[0].count }}人が参加
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <div class="col-10 px-0" style="margin:0 5px;">
                                                                <a :href="'/card/detail/' + popular_cards[3].id">
                                                                    <div class="card"
                                                                        style="max-width: 540px;border:0px;">
                                                                        <div class="row g-0">
                                                                            <div class="col-3">
                                                                                <div
                                                                                    v-if="popular_cards[3].card_count == 0">
                                                                                    <img :src="popular_cards[3].thumbnail_image"
                                                                                        class="luna-rounded img-fluid">
                                                                                </div>
                                                                                <div style="position:relative" v-else>

                                                                                    <svg
                                                                                        style="position:absolute;right:8px;top:5px;fill:#9990FF;z-index:99;height:25px;width:25px;">
                                                                                        <use
                                                                                            xlink:href="/images/card_check.svg#card_check">
                                                                                        </use>
                                                                                    </svg>
                                                                                    <img :src="popular_cards[3].thumbnail_image"
                                                                                        class="luna-rounded img-fluid"
                                                                                        style="border:3px solid #9990FF;">
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-9">
                                                                                <div style="padding-left:10px">
                                                                                    <div
                                                                                        style="font-size:14px;color:#000">
                                                                                        {{ popular_cards[3].name }}<span
                                                                                            v-if="popular_cards[3].card_count != 0"
                                                                                            style="color:#9990FF;">&nbsp;登録済</span>
                                                                                    </div>
                                                                                    <div
                                                                                        style="font-size:14px;color:#999">
                                                                                        {{ popular_cards[3].category
                                                                                        }}・{{
                                                                                            popular_cards[3].count }}人が参加
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <div class="col-10 px-0" style="margin:0 5px;">
                                                                <a :href="'/card/detail/' + popular_cards[6].id">
                                                                    <div class="card"
                                                                        style="max-width: 540px;border:0px;">
                                                                        <div class="row g-0">
                                                                            <div class="col-3">
                                                                                <div
                                                                                    v-if="popular_cards[6].card_count == 0">
                                                                                    <img :src="popular_cards[6].thumbnail_image"
                                                                                        class="luna-rounded img-fluid">
                                                                                </div>
                                                                                <div style="position:relative" v-else>

                                                                                    <svg
                                                                                        style="position:absolute;right:8px;top:5px;fill:#9990FF;z-index:99;height:25px;width:25px;">
                                                                                        <use
                                                                                            xlink:href="/images/card_check.svg#card_check">
                                                                                        </use>
                                                                                    </svg>
                                                                                    <img :src="popular_cards[6].thumbnail_image"
                                                                                        class="luna-rounded img-fluid"
                                                                                        style="border:3px solid #9990FF;">
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-9">
                                                                                <div style="padding-left:10px">
                                                                                    <div
                                                                                        style="font-size:14px;color:#000">
                                                                                        {{ popular_cards[6].name }}<span
                                                                                            v-if="popular_cards[6].card_count != 0"
                                                                                            style="color:#9990FF;">&nbsp;登録済</span>
                                                                                    </div>
                                                                                    <div
                                                                                        style="font-size:14px;color:#999">
                                                                                        {{ popular_cards[6].category
                                                                                        }}・{{
                                                                                            popular_cards[6].count }}人が参加
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div class="row flex-nowrap" style="padding:10px;">
                                                            <div class="col-10 px-0" style="margin:0 5px;">
                                                                <a :href="'/card/detail/' + popular_cards[1].id">
                                                                    <div class="card"
                                                                        style="max-width: 540px;border:0px;">
                                                                        <div class="row g-0">
                                                                            <div class="col-3">
                                                                                <div
                                                                                    v-if="popular_cards[1].card_count == 0">
                                                                                    <img :src="popular_cards[1].thumbnail_image"
                                                                                        class="luna-rounded img-fluid">
                                                                                </div>
                                                                                <div style="position:relative" v-else>

                                                                                    <svg
                                                                                        style="position:absolute;right:8px;top:5px;fill:#9990FF;z-index:99;height:25px;width:25px;">
                                                                                        <use
                                                                                            xlink:href="/images/card_check.svg#card_check">
                                                                                        </use>
                                                                                    </svg>
                                                                                    <img :src="popular_cards[1].thumbnail_image"
                                                                                        class="luna-rounded img-fluid"
                                                                                        style="border:3px solid #9990FF;">
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-9">
                                                                                <div style="padding-left:10px">
                                                                                    <div
                                                                                        style="font-size:14px;color:#000">
                                                                                        {{ popular_cards[1].name }}<span
                                                                                            v-if="popular_cards[1].card_count != 0"
                                                                                            style="color:#9990FF;">&nbsp;登録済</span>
                                                                                    </div>
                                                                                    <div
                                                                                        style="font-size:14px;color:#999">
                                                                                        {{ popular_cards[1].category
                                                                                        }}・{{
                                                                                            popular_cards[1].count }}人が参加
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <div class="col-10 px-0" style="margin:0 5px;">
                                                                <a :href="'/card/detail/' + popular_cards[4].id">
                                                                    <div class="card"
                                                                        style="max-width: 540px;border:0px;">
                                                                        <div class="row g-0">
                                                                            <div class="col-3">
                                                                                <div
                                                                                    v-if="popular_cards[4].card_count == 0">
                                                                                    <img :src="popular_cards[4].thumbnail_image"
                                                                                        class="luna-rounded img-fluid">
                                                                                </div>
                                                                                <div style="position:relative" v-else>

                                                                                    <svg
                                                                                        style="position:absolute;right:8px;top:5px;fill:#9990FF;z-index:99;height:25px;width:25px;">
                                                                                        <use
                                                                                            xlink:href="/images/card_check.svg#card_check">
                                                                                        </use>
                                                                                    </svg>
                                                                                    <img :src="popular_cards[4].thumbnail_image"
                                                                                        class="luna-rounded img-fluid"
                                                                                        style="border:3px solid #9990FF;">
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-9">
                                                                                <div style="padding-left:10px">
                                                                                    <div
                                                                                        style="font-size:14px;color:#000">
                                                                                        {{ popular_cards[4].name }}<span
                                                                                            v-if="popular_cards[4].card_count != 0"
                                                                                            style="color:#9990FF;">&nbsp;登録済</span>
                                                                                    </div>
                                                                                    <div
                                                                                        style="font-size:14px;color:#999">
                                                                                        {{ popular_cards[4].category
                                                                                        }}・{{
                                                                                            popular_cards[4].count }}人が参加
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <div class="col-10 px-0" style="margin:0 5px;">
                                                                <a :href="'/card/detail/' + popular_cards[7].id">
                                                                    <div class="card"
                                                                        style="max-width: 540px;border:0px;">
                                                                        <div class="row g-0">
                                                                            <div class="col-3">
                                                                                <div
                                                                                    v-if="popular_cards[7].card_count == 0">
                                                                                    <img :src="popular_cards[7].thumbnail_image"
                                                                                        class="luna-rounded img-fluid">
                                                                                </div>
                                                                                <div style="position:relative" v-else>

                                                                                    <svg
                                                                                        style="position:absolute;right:8px;top:5px;fill:#9990FF;z-index:99;height:25px;width:25px;">
                                                                                        <use
                                                                                            xlink:href="/images/card_check.svg#card_check">
                                                                                        </use>
                                                                                    </svg>
                                                                                    <img :src="popular_cards[7].thumbnail_image"
                                                                                        class="luna-rounded img-fluid"
                                                                                        style="border:3px solid #9990FF;">
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-9">
                                                                                <div style="padding-left:10px">
                                                                                    <div
                                                                                        style="font-size:14px;color:#000">
                                                                                        {{ popular_cards[7].name }}<span
                                                                                            v-if="popular_cards[7].card_count != 0"
                                                                                            style="color:#9990FF;">&nbsp;登録済</span>
                                                                                    </div>
                                                                                    <div
                                                                                        style="font-size:14px;color:#999">
                                                                                        {{ popular_cards[7].category
                                                                                        }}・{{
                                                                                            popular_cards[7].count }}人が参加
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div class="row flex-nowrap" style="padding:10px;">
                                                            <div class="col-10 px-0" style="margin:0 5px;">
                                                                <a :href="'/card/detail/' + popular_cards[2].id">
                                                                    <div class="card"
                                                                        style="max-width: 540px;border:0px;">
                                                                        <div class="row g-0">
                                                                            <div class="col-3">
                                                                                <div
                                                                                    v-if="popular_cards[2].card_count == 0">
                                                                                    <img :src="popular_cards[2].thumbnail_image"
                                                                                        class="luna-rounded img-fluid">
                                                                                </div>
                                                                                <div style="position:relative" v-else>

                                                                                    <svg
                                                                                        style="position:absolute;right:8px;top:5px;fill:#9990FF;z-index:99;height:25px;width:25px;">
                                                                                        <use
                                                                                            xlink:href="/images/card_check.svg#card_check">
                                                                                        </use>
                                                                                    </svg>
                                                                                    <img :src="popular_cards[2].thumbnail_image"
                                                                                        class="luna-rounded img-fluid"
                                                                                        style="border:3px solid #9990FF;">
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-9">
                                                                                <div style="padding-left:10px">
                                                                                    <div
                                                                                        style="font-size:14px;color:#000">
                                                                                        {{ popular_cards[2].name }}<span
                                                                                            v-if="popular_cards[2].card_count != 0"
                                                                                            style="color:#9990FF;">&nbsp;登録済</span>
                                                                                    </div>
                                                                                    <div
                                                                                        style="font-size:14px;color:#999">
                                                                                        {{ popular_cards[2].category
                                                                                        }}・{{
                                                                                            popular_cards[2].count }}人が参加
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <div class="col-10 px-0" style="margin:0 5px;">
                                                                <a :href="'/card/detail/' + popular_cards[5].id">
                                                                    <div class="card"
                                                                        style="max-width: 540px;border:0px;">
                                                                        <div class="row g-0">
                                                                            <div class="col-3">
                                                                                <div
                                                                                    v-if="popular_cards[5].card_count == 0">
                                                                                    <img :src="popular_cards[5].thumbnail_image"
                                                                                        class="luna-rounded img-fluid">
                                                                                </div>
                                                                                <div style="position:relative" v-else>

                                                                                    <svg
                                                                                        style="position:absolute;right:8px;top:5px;fill:#9990FF;z-index:99;height:25px;width:25px;">
                                                                                        <use
                                                                                            xlink:href="/images/card_check.svg#card_check">
                                                                                        </use>
                                                                                    </svg>
                                                                                    <img :src="popular_cards[5].thumbnail_image"
                                                                                        class="luna-rounded img-fluid"
                                                                                        style="border:3px solid #9990FF;">
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-9">
                                                                                <div style="padding-left:10px">
                                                                                    <div
                                                                                        style="font-size:14px;color:#000">
                                                                                        {{ popular_cards[5].name }}<span
                                                                                            v-if="popular_cards[5].card_count != 0"
                                                                                            style="color:#9990FF;">&nbsp;登録済</span>
                                                                                    </div>
                                                                                    <div
                                                                                        style="font-size:14px;color:#999">
                                                                                        {{ popular_cards[5].category
                                                                                        }}・{{
                                                                                            popular_cards[5].count }}人が参加
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <div class="col-10 px-0" style="margin:0 5px;">
                                                                <a :href="'/card/detail/' + popular_cards[8].id">
                                                                    <div class="card"
                                                                        style="max-width: 540px;border:0px;">
                                                                        <div class="row g-0">
                                                                            <div class="col-3">
                                                                                <div
                                                                                    v-if="popular_cards[8].card_count == 0">
                                                                                    <img :src="popular_cards[8].thumbnail_image"
                                                                                        class="luna-rounded img-fluid">
                                                                                </div>
                                                                                <div style="position:relative" v-else>

                                                                                    <svg
                                                                                        style="position:absolute;right:8px;top:5px;fill:#9990FF;z-index:99;height:25px;width:25px;">
                                                                                        <use
                                                                                            xlink:href="/images/card_check.svg#card_check">
                                                                                        </use>
                                                                                    </svg>
                                                                                    <img :src="popular_cards[8].thumbnail_image"
                                                                                        class="luna-rounded img-fluid"
                                                                                        style="border:3px solid #9990FF;">
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-9">
                                                                                <div style="padding-left:10px">
                                                                                    <div
                                                                                        style="font-size:14px;color:#000">
                                                                                        {{ popular_cards[8].name }}<span
                                                                                            v-if="popular_cards[8].card_count != 0"
                                                                                            style="color:#9990FF;">&nbsp;登録済</span>
                                                                                    </div>
                                                                                    <div
                                                                                        style="font-size:14px;color:#999">
                                                                                        {{ popular_cards[8].category
                                                                                        }}・{{
                                                                                            popular_cards[8].count }}人が参加
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col text-start" style="padding-top: 25px;">
                                    <b>新着カード</b>
                                </div>
                                <div class="col text-end" style="padding-top: 25px;color:#999;font-size:13px;">
                                    <a href="/card/new/list" style="color:#999;font-size:13px;">
                                        すべて見る
                                    </a>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="table-responsive">
                                        <table class="table table-borderless p-0">
                                            <tbody class="p-0">
                                                <tr class="p-0">
                                                    <td class="p-0">
                                                        <div class="row flex-nowrap" style="padding:10px;">
                                                            <div class="col-10 px-0" style="margin:0 5px;">
                                                                <a :href="'/card/detail/' + new_cards[0].id">
                                                                    <div class="card"
                                                                        style="max-width: 540px;border:0px;">
                                                                        <div class="row g-0">
                                                                            <div class="col-3">
                                                                                <div
                                                                                    v-if="new_cards[0].card_count == 0">
                                                                                    <img :src="new_cards[0].thumbnail_image"
                                                                                        class="luna-rounded img-fluid">
                                                                                </div>
                                                                                <div style="position:relative" v-else>

                                                                                    <svg
                                                                                        style="position:absolute;right:8px;top:5px;fill:#9990FF;z-index:99;height:25px;width:25px;">
                                                                                        <use
                                                                                            xlink:href="/images/card_check.svg#card_check">
                                                                                        </use>
                                                                                    </svg>
                                                                                    <img :src="new_cards[0].thumbnail_image"
                                                                                        class="luna-rounded img-fluid"
                                                                                        style="border:3px solid #9990FF;">
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-9">
                                                                                <div style="padding-left:10px">
                                                                                    <div
                                                                                        style="font-size:14px;color:#000">
                                                                                        {{ new_cards[0].name }}<span
                                                                                            v-if="new_cards[0].card_count != 0"
                                                                                            style="color:#9990FF;">&nbsp;登録済</span>
                                                                                    </div>
                                                                                    <div
                                                                                        style="font-size:14px;color:#999">
                                                                                        {{ new_cards[0].category }}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <div class="col-10 px-0" style="margin:0 5px;">
                                                                <a :href="'/card/detail/' + new_cards[3].id">
                                                                    <div class="card"
                                                                        style="max-width: 540px;border:0px;">
                                                                        <div class="row g-0">
                                                                            <div class="col-3">
                                                                                <div
                                                                                    v-if="new_cards[3].card_count == 0">
                                                                                    <img :src="new_cards[3].thumbnail_image"
                                                                                        class="luna-rounded img-fluid">
                                                                                </div>
                                                                                <div style="position:relative" v-else>

                                                                                    <svg
                                                                                        style="position:absolute;right:8px;top:5px;fill:#9990FF;z-index:99;height:25px;width:25px;">
                                                                                        <use
                                                                                            xlink:href="/images/card_check.svg#card_check">
                                                                                        </use>
                                                                                    </svg>
                                                                                    <img :src="new_cards[3].thumbnail_image"
                                                                                        class="luna-rounded img-fluid"
                                                                                        style="border:3px solid #9990FF;">
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-9">
                                                                                <div style="padding-left:10px">
                                                                                    <div
                                                                                        style="font-size:14px;color:#000">
                                                                                        {{ new_cards[3].name }}<span
                                                                                            v-if="new_cards[3].card_count != 0"
                                                                                            style="color:#9990FF;">&nbsp;登録済</span>
                                                                                    </div>
                                                                                    <div
                                                                                        style="font-size:14px;color:#999">
                                                                                        {{ new_cards[3].category }}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <div class="col-10 px-0" style="margin:0 5px;">
                                                                <a :href="'/card/detail/' + new_cards[6].id">
                                                                    <div class="card"
                                                                        style="max-width: 540px;border:0px;">
                                                                        <div class="row g-0">
                                                                            <div class="col-3">
                                                                                <div
                                                                                    v-if="new_cards[6].card_count == 0">
                                                                                    <img :src="new_cards[6].thumbnail_image"
                                                                                        class="luna-rounded img-fluid">
                                                                                </div>
                                                                                <div style="position:relative" v-else>

                                                                                    <svg
                                                                                        style="position:absolute;right:8px;top:5px;fill:#9990FF;z-index:99;height:25px;width:25px;">
                                                                                        <use
                                                                                            xlink:href="/images/card_check.svg#card_check">
                                                                                        </use>
                                                                                    </svg>
                                                                                    <img :src="new_cards[6].thumbnail_image"
                                                                                        class="luna-rounded img-fluid"
                                                                                        style="border:3px solid #9990FF;">
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-9">
                                                                                <div style="padding-left:10px">
                                                                                    <div
                                                                                        style="font-size:14px;color:#000">
                                                                                        {{ new_cards[6].name }}<span
                                                                                            v-if="new_cards[6].card_count != 0"
                                                                                            style="color:#9990FF;">&nbsp;登録済</span>
                                                                                    </div>
                                                                                    <div
                                                                                        style="font-size:14px;color:#999">
                                                                                        {{ new_cards[6].category }}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div class="row flex-nowrap" style="padding:10px;">
                                                            <div class="col-10 px-0" style="margin:0 5px;">
                                                                <a :href="'/card/detail/' + new_cards[1].id">
                                                                    <div class="card"
                                                                        style="max-width: 540px;border:0px;">
                                                                        <div class="row g-0">
                                                                            <div class="col-3">
                                                                                <div
                                                                                    v-if="new_cards[1].card_count == 0">
                                                                                    <img :src="new_cards[1].thumbnail_image"
                                                                                        class="luna-rounded img-fluid">
                                                                                </div>
                                                                                <div style="position:relative" v-else>

                                                                                    <svg
                                                                                        style="position:absolute;right:8px;top:5px;fill:#9990FF;z-index:99;height:25px;width:25px;">
                                                                                        <use
                                                                                            xlink:href="/images/card_check.svg#card_check">
                                                                                        </use>
                                                                                    </svg>
                                                                                    <img :src="new_cards[1].thumbnail_image"
                                                                                        class="luna-rounded img-fluid"
                                                                                        style="border:3px solid #9990FF;">
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-9">
                                                                                <div style="padding-left:10px">
                                                                                    <div
                                                                                        style="font-size:14px;color:#000">
                                                                                        {{ new_cards[1].name }}<span
                                                                                            v-if="new_cards[1].card_count != 0"
                                                                                            style="color:#9990FF;">&nbsp;登録済</span>
                                                                                    </div>
                                                                                    <div
                                                                                        style="font-size:14px;color:#999">
                                                                                        {{ new_cards[1].category }}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <div class="col-10 px-0" style="margin:0 5px;">
                                                                <a :href="'/card/detail/' + new_cards[4].id">
                                                                    <div class="card"
                                                                        style="max-width: 540px;border:0px;">
                                                                        <div class="row g-0">
                                                                            <div class="col-3">
                                                                                <div
                                                                                    v-if="new_cards[4].card_count == 0">
                                                                                    <img :src="new_cards[4].thumbnail_image"
                                                                                        class="luna-rounded img-fluid">
                                                                                </div>
                                                                                <div style="position:relative" v-else>

                                                                                    <svg
                                                                                        style="position:absolute;right:8px;top:5px;fill:#9990FF;z-index:99;height:25px;width:25px;">
                                                                                        <use
                                                                                            xlink:href="/images/card_check.svg#card_check">
                                                                                        </use>
                                                                                    </svg>
                                                                                    <img :src="new_cards[4].thumbnail_image"
                                                                                        class="luna-rounded img-fluid"
                                                                                        style="border:3px solid #9990FF;">
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-9">
                                                                                <div style="padding-left:10px">
                                                                                    <div
                                                                                        style="font-size:14px;color:#000">
                                                                                        {{ new_cards[4].name }}<span
                                                                                            v-if="new_cards[4].card_count != 0"
                                                                                            style="color:#9990FF;">&nbsp;登録済</span>
                                                                                    </div>
                                                                                    <div
                                                                                        style="font-size:14px;color:#999">
                                                                                        {{ new_cards[4].category }}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <div class="col-10 px-0" style="margin:0 5px;">
                                                                <a :href="'/card/detail/' + new_cards[7].id">
                                                                    <div class="card"
                                                                        style="max-width: 540px;border:0px;">
                                                                        <div class="row g-0">
                                                                            <div class="col-3">
                                                                                <div
                                                                                    v-if="new_cards[7].card_count == 0">
                                                                                    <img :src="new_cards[7].thumbnail_image"
                                                                                        class="luna-rounded img-fluid">
                                                                                </div>
                                                                                <div style="position:relative" v-else>

                                                                                    <svg
                                                                                        style="position:absolute;right:8px;top:5px;fill:#9990FF;z-index:99;height:25px;width:25px;">
                                                                                        <use
                                                                                            xlink:href="/images/card_check.svg#card_check">
                                                                                        </use>
                                                                                    </svg>
                                                                                    <img :src="new_cards[7].thumbnail_image"
                                                                                        class="luna-rounded img-fluid"
                                                                                        style="border:3px solid #9990FF;">
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-9">
                                                                                <div style="padding-left:10px">
                                                                                    <div
                                                                                        style="font-size:14px;color:#000">
                                                                                        {{ new_cards[7].name }}<span
                                                                                            v-if="new_cards[7].card_count != 0"
                                                                                            style="color:#9990FF;">&nbsp;登録済</span>
                                                                                    </div>
                                                                                    <div
                                                                                        style="font-size:14px;color:#999">
                                                                                        {{ new_cards[7].category }}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div class="row flex-nowrap" style="padding:10px;">
                                                            <div class="col-10 px-0" style="margin:0 5px;">
                                                                <a :href="'/card/detail/' + new_cards[2].id">
                                                                    <div class="card"
                                                                        style="max-width: 540px;border:0px;">
                                                                        <div class="row g-0">
                                                                            <div class="col-3">
                                                                                <div
                                                                                    v-if="new_cards[2].card_count == 0">
                                                                                    <img :src="new_cards[2].thumbnail_image"
                                                                                        class="luna-rounded img-fluid">
                                                                                </div>
                                                                                <div style="position:relative" v-else>

                                                                                    <svg
                                                                                        style="position:absolute;right:8px;top:5px;fill:#9990FF;z-index:99;height:25px;width:25px;">
                                                                                        <use
                                                                                            xlink:href="/images/card_check.svg#card_check">
                                                                                        </use>
                                                                                    </svg>
                                                                                    <img :src="new_cards[2].thumbnail_image"
                                                                                        class="luna-rounded img-fluid"
                                                                                        style="border:3px solid #9990FF;">
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-9">
                                                                                <div style="padding-left:10px">
                                                                                    <div
                                                                                        style="font-size:14px;color:#000">
                                                                                        {{ new_cards[2].name }}<span
                                                                                            v-if="new_cards[2].card_count != 0"
                                                                                            style="color:#9990FF;">&nbsp;登録済</span>
                                                                                    </div>
                                                                                    <div
                                                                                        style="font-size:14px;color:#999">
                                                                                        {{ new_cards[2].category }}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <div class="col-10 px-0" style="margin:0 5px;">
                                                                <a :href="'/card/detail/' + new_cards[5].id">
                                                                    <div class="card"
                                                                        style="max-width: 540px;border:0px;">
                                                                        <div class="row g-0">
                                                                            <div class="col-3">
                                                                                <div
                                                                                    v-if="new_cards[5].card_count == 0">
                                                                                    <img :src="new_cards[5].thumbnail_image"
                                                                                        class="luna-rounded img-fluid">
                                                                                </div>
                                                                                <div style="position:relative" v-else>

                                                                                    <svg
                                                                                        style="position:absolute;right:8px;top:5px;fill:#9990FF;z-index:99;height:25px;width:25px;">
                                                                                        <use
                                                                                            xlink:href="/images/card_check.svg#card_check">
                                                                                        </use>
                                                                                    </svg>
                                                                                    <img :src="new_cards[5].thumbnail_image"
                                                                                        class="luna-rounded img-fluid"
                                                                                        style="border:3px solid #9990FF;">
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-9">
                                                                                <div style="padding-left:10px">
                                                                                    <div
                                                                                        style="font-size:14px;color:#000">
                                                                                        {{ new_cards[5].name }}<span
                                                                                            v-if="new_cards[5].card_count != 0"
                                                                                            style="color:#9990FF;">&nbsp;登録済</span>
                                                                                    </div>
                                                                                    <div
                                                                                        style="font-size:14px;color:#999">
                                                                                        {{ new_cards[5].category }}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <div class="col-10 px-0" style="margin:0 5px;">
                                                                <a :href="'/card/detail/' + new_cards[8].id">
                                                                    <div class="card"
                                                                        style="max-width: 540px;border:0px;">
                                                                        <div class="row g-0">
                                                                            <div class="col-3">
                                                                                <div
                                                                                    v-if="new_cards[8].card_count == 0">
                                                                                    <img :src="new_cards[8].thumbnail_image"
                                                                                        class="luna-rounded img-fluid">
                                                                                </div>
                                                                                <div style="position:relative" v-else>

                                                                                    <svg
                                                                                        style="position:absolute;right:8px;top:5px;fill:#9990FF;z-index:99;height:25px;width:25px;">
                                                                                        <use
                                                                                            xlink:href="/images/card_check.svg#card_check">
                                                                                        </use>
                                                                                    </svg>
                                                                                    <img :src="new_cards[8].thumbnail_image"
                                                                                        class="luna-rounded img-fluid"
                                                                                        style="border:3px solid #9990FF;">
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-9">
                                                                                <div style="padding-left:10px">
                                                                                    <div
                                                                                        style="font-size:14px;color:#000">
                                                                                        {{ new_cards[8].name }}<span
                                                                                            v-if="new_cards[8].card_count != 0"
                                                                                            style="color:#9990FF;">&nbsp;登録済</span>
                                                                                    </div>
                                                                                    <div
                                                                                        style="font-size:14px;color:#999">
                                                                                        {{ new_cards[8].category }}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col text-start" style="padding-top: 25px;">
                                    <b>カード一覧</b>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4 px-0" v-for="card in cards" :key="card.id">
                                    <a :href="'/card/detail/' + card.id" style="color:#000;">
                                        <div style="margin:8px;" v-if="card.count == 0">
                                            <img :src="card.thumbnail_image" class="luna-rounded img-fluid">
                                            <div style="padding:3px;font-size:12px">{{ card.name }}</div>
                                        </div>
                                        <div style="margin:8px;position:relative" v-else>
                                            <svg
                                                style="position:absolute;right:8px;top:5px;fill:#9990FF;z-index:99;height:30px;width:30px;">
                                                <use xlink:href="/images/card_check.svg#card_check"></use>
                                            </svg>
                                            <img :src="card.thumbnail_image" class="luna-rounded img-fluid"
                                                style="border:3px solid #9990FF;">
                                            <div style="padding:3px;font-size:12px">{{ card.name }}</div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div class="row" v-if="count != 0">
                                <div class="col">
                                    <div class="text-center"
                                        style="padding-top: 40px; padding-bottom: 20px; color: #6c7072"
                                        v-if="is_page && count != 0">
                                        <a @click="fetchCardMore()">もっとみる</a>
                                    </div>
                                    <div class="text-center" v-else-if="advertisements_footer.length != 0">
                                        <br>
                                        <a :href="advertisements_footer[ad_footer_index].link_url" target="_blank">
                                            <img :src="advertisements_footer[ad_footer_index].ad_image"
                                                class="img-fluid" />
                                        </a>
                                        <br>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="is_load_under">
                                <div class="col text-center">
                                    <div class="spinner-grow" role="status">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br>
                <br>
                <br>
                <br>
                <br>
                <br>
                <br>
                <br>
            </div>
        </div>
        <div>
            <div class="luna-footer-card-now" v-if="my_cards_count < 20">
                <div style="background-color: #333333cc;
                    height: 80px;
                    width: 280px;
                    border-radius: 10px;
                    padding: 5px;">
                    <div style="display:flex;">
                        <div class="text-center" style="background-color: #333333;
                        height: 70px;
                        width:70px;
                        color: #fff;
                        font-size: 10px;
                        border-radius: 10px;
                        padding: 3px;">
                            <div style="transform: scale(0.8);">好みのカード<br>登録数</div>
                            <div style="padding-left: 9px;margin-top: -3px;">
                                <span style="font-size: 25px;">{{ my_cards_count }}</span>
                                <span style="font-size:10px;transform: scale(0.8);">こ</span>
                            </div>
                        </div>
                        <div class="text-start" style="padding-left: 9px;font-size:12px;color:#fff;">
                            <span style="color:#FDD000;font-size:20px;">20こ</span>
                            登録すると<br />マッチングされやすくなります<br />
                            <span style="font-size: 10px;transform: scale(0.8);">※ 無料10こまで 有料50こまで</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="luna-footer-card-entry">
                <a href="/card/entry">
                    <img src="/images/Group13174.png" width="50" height="50">
                </a>
            </div>
        </div>
        <FooterMenu currentPage="card" />
    </div>
</template>

<script>
import FooterMenu from '../components/FooterMenu.vue';

export default {
    components: {
        FooterMenu,
    },
    data() {
        return {
            advertisements: [],
            advertisements_page: [],
            advertisements_footer: [],
            ad_index: 0,
            ad_page_index: 0,
            ad_footer_index: 0,
            user: [],
            categorys: [],
            cards: [],
            new_cards: [],
            popular_cards: [],
            my_cards: [],
            my_cards_count: 0,
            is_my_cards_page: true,
            is_my_cards_load_under: false,
            my_cards_page: 1,
            count: 0,
            is_page: true,
            is_load_under: false,
            page: 1,
            search_word: "",

            is_page_init_my_card: true,
            is_page_init_card: true,
            is_page_init_attention_card: true,

            is_pagenation: true,
            info_count: 0,
        };
    },
    mouted: function () {
        window.addEventListener("scroll", this.handleScroll)
    },
    methods: {
        async getAdvertisements() {
            axios.get("/api/advertisement/get/3")
                .then((response) => {
                    this.advertisements = response.data.advertisements
                })
            axios.get("/api/advertisement/get/10")
                .then((response) => {
                    this.advertisements_page = response.data.advertisements
                })
            axios.get("/api/advertisement/get/11")
                .then((response) => {
                    this.advertisements_footer = response.data.advertisements
                })
        },
        async getUnreadCount() {
            await axios.get("/api/information/count/get")
                .then(
                    (response) => {
                        this.info_count = response.data.count
                    }
                )
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("通知情報の取得に失敗しました。")
                    }
                })
        },
        async init() {
            await axios.get("/api/auth/user/get")
                .then(
                    () => {
                        this.fetchUsers()
                    }
                )
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザ情報の取得に失敗しました")
                    }
                })
        },
        async fetchUsers() {
            await axios.get("/api/user/get/me")
                .then((response) => {
                    this.user = response.data.user
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザ情報の取得に失敗しました")
                    }
                })
        },
        async fetchCategory() {
            await axios.get("/api/card/category/list")
                .then((response) => {
                    this.categorys = response.data.categorys
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("カテゴリの取得に失敗しました")
                    }
                })
        },
        async fetchMyCard() {
            await axios.get("/api/card/my")
                .then((response) => {
                    this.my_cards = response.data.my_cards.data
                    this.my_cards_count = response.data.my_cards_count

                    if (this.my_cards_count <= 6) {
                        this.is_my_cards_page = false
                    }
                    this.is_page_init_my_card = false
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("登録済みカードの取得に失敗しました")
                    }
                })
        },
        async fetchMyCardMore() {
            this.is_my_cards_load_under = true
            this.my_cards_page++

            await axios.get("/api/card/my" + "?page=" + this.my_cards_page)
                .then((response) => {
                    this.my_cards.push.apply(this.my_cards, response.data.my_cards.data)
                    this.is_my_cards_load_under = false

                    if (response.data.my_cards.data.length == 0) {
                        this.is_my_cards_page = false
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("登録済みカードの取得に失敗しました")
                    }
                })
        },
        async fetchCard() {
            await axios.get("/api/card/list")
                .then((response) => {
                    let _cards = response.data.cards.data
                    let indexs = response.data.indexs
                    this.count = response.data.count

                    /*                   let ads = this.advertisements
                                      let i = this.ad_index

                                      indexs.forEach(function (val) {
                                          if (val < _cards.length) {
                                              let ad = ads[i]

                                              _cards[val].ad_image = ad.ad_image
                                              _cards[val].link_url = ad.link_url

                                              i++

                                              if (ads.length <= i) {
                                                  i = 0
                                              }
                                          }
                                      })
                   */
                    this.cards = _cards

                    if (this.count <= 9) {
                        this.is_page = false
                    }
                    this.is_page_init_card = false
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("カードの取得に失敗しました")
                    }
                })
        },
        async fetchCardMore() {
            this.is_load_under = true
            this.page++

            await axios.get("/api/card/list" + "?page=" + this.page)
                .then((response) => {
                    let _cards = response.data.cards.data
                    let indexs = response.data.indexs
                    /*
                                        let ads = this.advertisements
                                        let i = this.ad_index

                                        indexs.forEach(function (val) {
                                            if (val < _cards.length) {
                                                let ad = ads[i]

                                                _cards[val].ad_image = ad.ad_image
                                                _cards[val].link_url = ad.link_url

                                                i++

                                                if (ads.length <= i) {
                                                    i = 0
                                                }
                                            }
                                        })

                                        if ((this.page % 4) == 0) {
                                            if (this.advertisements_page.length != 0) {

                                                let p = this.ad_page_index
                                                let ad_page = {
                                                    id: 0,
                                                    category_id: 99998,
                                                    ad_image: this.advertisements_page[p].ad_image,
                                                    link_url: this.advertisements_page[p].link_url
                                                }

                                                p++

                                                if (this.advertisements_page.length <= p) {
                                                    p = 0
                                                }

                                                this.ad_page_index = p

                                                _cards.push(ad_page)
                                            }
                                        }
                     */
                    this.cards.push.apply(this.cards, _cards)

                    if (response.data.cards.data.length == 0) {
                        this.is_page = false
                    }
                    this.is_pagenation = true
                })
                .catch((error) => {
                    console.log(error)
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("カードの取得に失敗しました")
                    }
                }).finally(() => {
                    this.is_load_under = false
                })
        },
        async handleScroll() {
            let bottom = document.body.scrollHeight - document.body.clientHeight

            this.scrollY = window.scrollY
            let p = Math.abs(bottom - this.scrollY)

            if (p < 1 && this.is_page && this.is_pagenation) {
                this.is_pagenation = false
                this.fetchCardMore()
            }
        },
        async fetchAttentionCard() {
            await axios.get("/api/card/attention/list")
                .then((response) => {
                    this.new_cards = response.data.new_cards
                    this.popular_cards = response.data.popular_cards

                    this.is_page_init_attention_card = false
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("登録済みカードの取得に失敗しました", false)
                    }
                })
        },
        setWord() {
            localStorage.setItem('search_word', this.search_word)
            window.location.href = "/card/search"
        }
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.getUnreadCount()
                            this.init()
                            this.fetchCategory()
                            this.fetchCard()
                            this.fetchMyCard()
                            this.fetchAttentionCard()
                        })
                    .catch((error) => {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    })
            }
            else {
                this.getUnreadCount()
                this.init()
                this.fetchCategory()
                this.fetchCard()
                this.fetchMyCard()
                this.fetchAttentionCard()
            }
        }
        else {
            this.getUnreadCount()
            this.init()
            this.fetchCategory()
            this.fetchCard()
            this.fetchMyCard()
            this.fetchAttentionCard()
        }
    },
    mounted() {
        window.addEventListener("scroll", this.handleScroll)
    },
};
</script>
<style scoped>
a {
    text-decoration: none;
}

.category-box {
    padding: 20px 20px;
    background-color: #6b4eff;
    color: #fff;
    border-radius: 10px;
    font-size: 13px;
}

.category-box-filter {
    padding: 20px 20px;
    background-color: rgba(0, 0, 0, 0.6);
    color: #fff;
    border-radius: 10px;
    font-size: 13px;
}

.luna-footer-card-entry {
    position: fixed;
    bottom: 65px;
    right: initial;
    margin-left: 480px;
    z-index: 99999;
}

.luna-footer-card-now {
    position: fixed;
    bottom: 65px;
    left: initial;
    margin-left: 15px;
    z-index: 99999;
}

.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    height: 56px;
    width: 540px;
    background-color: #fff;
    z-index: 999;
}


@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }

    .luna-footer-card-entry {
        right: 15px;
        margin-left: initial;
    }

    .luna-footer-card-now {
        left: 15px;
        margin-left: initial;
    }
}


.luna-rounded {
    border-radius: 20px;
}

.search_box {
    display: inline-block;
    /* なくても大丈夫だけど、念の為 */
    position: relative;
    /* 基準値とする */
    width: 100%;
    padding: 8px 0px;
    background-color: #F2F2F1;
    border-radius: 6px;
}

.search_box::before {
    content: "";
    /* 疑似要素に必須 */
    width: 18px;
    /* アイコンの横幅 */
    height: 18px;
    /* アイコンの高さ */
    background: url(./../../../../public/images/card_search.png) no-repeat center center / auto 100%;
    /* 背景にアイコン画像を配置 */
    display: inline-block;
    /* 高さを持たせるためにインラインブロック要素にする */
    position: absolute;
    /* 相対位置に指定 */
    top: 13px;
    /* アイコンの位置。微調整してね */
    left: 8px;
    /* アイコンの位置。微調整してね */
}

.search_box input {
    padding: 3px 0 3px 2em;
    /* アイコンを設置するため左の余白を多めに指定*/
    width: 100%;
    background-color: #F2F2F1;
    border: 0px;
    outline: none;
}
</style>
